import { useQuery } from "@apollo/client";
import { ADMIN_NOTIFICATION_LOG_MONITORING } from "../graphql";
import type { NotificationLogMonitoringPayload, NotificationLogStatus } from "../types";
import { POLL_INTERVAL_MS } from "../constants";

interface UseNotificationLogMonitoringOptions {
  status?: NotificationLogStatus;
  type?: string;
  userId?: string;
  first?: number;
  skip?: number;
  pollInterval?: number;
}

export function useNotificationLogMonitoring(options: UseNotificationLogMonitoringOptions = {}) {
  const {
    status,
    type,
    userId,
    first = 50,
    skip = 0,
    pollInterval = POLL_INTERVAL_MS,
  } = options;

  return useQuery<{ adminNotificationLogMonitoring: NotificationLogMonitoringPayload }>(
    ADMIN_NOTIFICATION_LOG_MONITORING,
    {
      variables: {
        status: status ?? undefined,
        type: type ?? undefined,
        userId: userId ?? undefined,
        first,
        skip,
      },
      fetchPolicy: "cache-and-network",
      pollInterval,
    },
  );
}
